/**
 * MS606 — Type C tier-upgrade paths (MS594 fulfilment registry).
 *
 * Documented base → higher-SKU replacements. These are NOT add-ons:
 * selecting an upgrade replaces the checkout line item.
 */

/** Base product id → ordered list of upgrade target product ids. */
export const PRODUCT_UPGRADE_PATHS: Readonly<Record<string, readonly string[]>> = {
  // Comma $89 Bath House session → $199 bath + massage combo
  "5c34c923-dad5-432a-a35e-8cfc02174f19": [
    "975d57fa-e11c-44f9-a989-c63efdfe1b7e",
  ],
  // Comma $199 combo → $349 couples premium
  "975d57fa-e11c-44f9-a989-c63efdfe1b7e": [
    "d1525875-3c1a-4fe3-9fbe-92be819c8e9e",
  ],
  // Benty Peaceful Bliss ($109) → Royal Grace ($174)
  "45d84e58-3549-49bb-a47d-2cea685e6b02": [
    "e666c8d8-3d50-4b2c-9b9e-4d1a13450a65",
  ],
  // Cremorne Celebration Hamper ($165) → Champagne & Luxury ($295)
  "eef01ac7-64b4-417d-baa2-6eb22a5ab740": [
    "62ea05a3-ce28-4a46-b4e8-f481cfac8f33",
  ],
  // The Hamper Boutique Co — tier ladder ($79 → $199)
  "ad4f4e69-e3f7-4512-b30c-3ef5e1e23c58": [
    "dd535868-59e4-4bd5-b4d1-6fa9cb009992",
  ],
  "dd535868-59e4-4bd5-b4d1-6fa9cb009992": [
    "b5213cc2-5a0d-4dad-954b-d997e8da280d",
  ],
  "b5213cc2-5a0d-4dad-954b-d997e8da280d": [
    "a2442d82-bc0c-4a85-b619-4ca8cc392c68",
  ],
  "a2442d82-bc0c-4a85-b619-4ca8cc392c68": [
    "b8623a31-e0e8-491a-9187-93f8111f62b5",
  ],
};

/** Upgrade targets for the active base SKU (may be empty). */
export function getUpgradeTargetIds(productId: string): readonly string[] {
  return PRODUCT_UPGRADE_PATHS[productId] ?? [];
}

/** Whether a candidate upgrade is valid for the current base selection. */
export function isValidUpgradeTarget(
  base: { price: number; is_voucher: boolean },
  target: { price: number; is_voucher: boolean },
): boolean {
  return target.price > base.price && target.is_voucher === base.is_voucher;
}
